export const statusColors = {
  pending: 'slate',
  errored: 'danger',
  running: 'warning',
  finished: 'success'
};
